
//References here are generated by AggregateTypesForUse.tst
export * from "./Auto/Interfaces/AccessEventType";
export * from "./Auto/Interfaces/AccessEvent";
export * from "./Auto/Interfaces/AccessHistory";
export * from "./Auto/Interfaces/AccessInfo";
export * from "./Auto/Interfaces/ActiveSessionStub";
export * from "./Auto/Interfaces/Address";
export * from "./Auto/Interfaces/AIData";
export * from "./Auto/Interfaces/AIHazardData";
export * from "./Auto/Interfaces/AILabel";
export * from "./Auto/Interfaces/AIMetadata";
export * from "./Auto/Interfaces/AIResponse";
export * from "./Auto/Interfaces/AIVideoFrameTag";
export * from "./Auto/Interfaces/AIVideoFrameTagHazard";
export * from "./Auto/Interfaces/Chat";
export * from "./Auto/Interfaces/ClientCompletedSessionStub";
export * from "./Auto/Interfaces/ClientFeedback";
export * from "./Auto/Interfaces/ClientInfo";
export * from "./Auto/Interfaces/ClientSession";
export * from "./Auto/Interfaces/CompletedSessionStub";
export * from "./Auto/Interfaces/Contact";
export * from "./Auto/Interfaces/Coordinates";
export * from "./Auto/Interfaces/CosmosEntityBase";
export * from "./Auto/Interfaces/Customer";
export * from "./Auto/Interfaces/DeviceBrowserClient";
export * from "./Auto/Interfaces/DeviceClient";
export * from "./Auto/Interfaces/DeviceInfo";
export * from "./Auto/Interfaces/DeviceOS";
export * from "./Auto/Interfaces/ExternalObserverOrderLocalization";
export * from "./Auto/Interfaces/ExternalObserverSession";
export * from "./Auto/Interfaces/ExternalObserverSessionInfo";
export * from "./Auto/Interfaces/Hazard_Identified";
export * from "./Auto/Interfaces/HeartbeatPing";
export * from "./Auto/Interfaces/HeartBeatRequest";
export * from "./Auto/Interfaces/HeartBeatResult";
export * from "./Auto/Interfaces/Image";
export * from "./Auto/Interfaces/ImageCultureCodeModel";
export * from "./Auto/Interfaces/ImageLocalization";
export * from "./Auto/Interfaces/ImageLocalizationResource";
export * from "./Auto/Interfaces/ImageLocalizations";
export * from "./Auto/Interfaces/ImageLocalizationViewModel";
export * from "./Auto/Interfaces/LiveSwitchTokenResult";
export * from "./Auto/Interfaces/Localization";
export * from "./Auto/Interfaces/LocalizationResource";
export * from "./Auto/Interfaces/Mentor";
export * from "./Auto/Interfaces/MentorSession";
export * from "./Auto/Interfaces/MentorToken";
export * from "./Auto/Interfaces/MentorUserInfo";
export * from "./Auto/Interfaces/Order";
export * from "./Auto/Interfaces/OrderLocalization";
export * from "./Auto/Interfaces/PhotoInfo";
export * from "./Auto/Interfaces/PhotoResult";
export * from "./Auto/Interfaces/PhotoTag";
export * from "./Auto/Interfaces/PhotoTagLabel";
export * from "./Auto/Interfaces/PhotoTagLabelLanguage";
export * from "./Auto/Interfaces/PhotoTagLanguage";
export * from "./Auto/Interfaces/PositionInfo";
export * from "./Auto/Interfaces/Product";
export * from "./Auto/Interfaces/ProductLanguage";
export * from "./Auto/Interfaces/QueuePlacementResult";
export * from "./Auto/Interfaces/RecordingToggle";
export * from "./Auto/Interfaces/Registration";
export * from "./Auto/Interfaces/ScheduleRequest";
export * from "./Auto/Interfaces/ScheduleRequestBody";
export * from "./Auto/Interfaces/ScheduleResult";
export * from "./Auto/Interfaces/Session";
export * from "./Auto/Interfaces/SessionInfo";
export * from "./Auto/Interfaces/SessionPhoto";
export * from "./Auto/Interfaces/SessionPhotoTag";
export * from "./Auto/Interfaces/SessionStub";
export * from "./Auto/Interfaces/Settings";
export * from "./Auto/Interfaces/TelemetryInfo";
export * from "./Auto/Interfaces/UpdateImageLocalizationModel";
export * from "./Auto/Interfaces/Video";
export * from "./Auto/Interfaces/VideoFrameTagInfo";
export * from "./Auto/Interfaces/AIPhotoTaggingBusinessType";
export * from "./Auto/Interfaces/CanvasQuality";
export * from "./Auto/Interfaces/ChatType";
export * from "./Auto/Interfaces/CloseOutType";
export * from "./Auto/Interfaces/DeviceTypes";
export * from "./Auto/Interfaces/ExecutionType";
export * from "./Auto/Interfaces/ObserverPhase";
export * from "./Auto/Interfaces/ParticipantStatus";
export * from "./Auto/Interfaces/ParticipantType";
export * from "./Auto/Interfaces/RecordingOption";
export * from "./Auto/Interfaces/SetScheduleResult";
export * from "./Auto/Interfaces/TagType";
export * from "./Auto/Interfaces/VideoType";

